
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-inline--fa fa-home-alt fa-w-18 fa-3x",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","data-icon":"home-alt","data-prefix":"fal","viewBox":"0 0 591.16 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#000","stroke-width":"11.048","d":"M122.19 9.617c-3.26 0-6.52 1.083-9.208 3.25L6.835 99.51a3.647 3.647 0 00-.529 5.126l4.607 5.66a3.648 3.648 0 005.108.54l18.631-15.219v91.894L49.245 175.6V83.71l72.964-59.543 56.285 45.931 11.518-9.402-58.615-47.829a14.638 14.638 0 00-9.208-3.25z"}}),_c('path',{attrs:{"d":"M573.189 234.881L315.945 24.976a35.53 35.53 0 00-44.61 0L14.179 234.881a8.838 8.838 0 00-1.281 12.418l11.158 13.71a8.838 8.838 0 0012.373 1.315l45.14-36.877v268.457a17.676 17.676 0 0017.677 17.676h141.41a17.676 17.676 0 0017.676-17.676v-141.41l70.704.332v141.498A17.676 17.676 0 00346.713 512l141.41-.365a17.676 17.676 0 0017.675-17.676V225.447l45.141 36.877a8.838 8.838 0 0012.429-1.282l11.158-13.71a8.838 8.838 0 00-1.337-12.45zm-102.865 241.49h.11l-106.056.332V335.105a17.731 17.731 0 00-17.621-17.676l-106.057-.298a17.676 17.676 0 00-17.732 17.676v141.564H116.922v-279.77L293.684 52.352l176.762 144.25z"}}),_c('path',{attrs:{"stroke":"#000","stroke-width":"11.048","d":"M468.97 5.524c3.26 0 6.52 1.082 9.207 3.25l106.148 86.643a3.647 3.647 0 01.53 5.126l-4.608 5.659a3.648 3.648 0 01-5.107.541l-18.633-15.22v91.894l-14.593-11.91v-91.89L468.95 20.074l-56.284 45.931-11.518-9.402 58.615-47.829a14.638 14.638 0 019.207-3.25z"}})])
          )
        }
      }
    